import Campaigns from '@/features/campaigns'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/campaigns/')({
  component: Campaigns,
})
